import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeCustomers } from './data/mockData'; // Import the function

// Ensure customers are initialized at startup
initializeCustomers();

console.log("running in " + import.meta.env.MODE + " mode");

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
